var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlaystoreBadge = function SvgPlaystoreBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 60,
    viewBox: "0 0 202.5 60"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".aaa{fill:#a6a6a6;}.b,.c,.j{fill:#fff;}.b{stroke:#fff;stroke-miterlimit:10;stroke-width:0.2px;}.d{fill:url(#aa);}.e{fill:url(#bb);}.f{fill:url(#cc);}.g{fill:url(#dd);}.h{opacity:0.2;}.i{opacity:0.12;}.j{opacity:0.25;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aa",
    x1: 0.908,
    y1: 1.032,
    x2: -0.383,
    y2: 0.36,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bb",
    x1: 1.077,
    y1: 0.729,
    x2: -1.307,
    y2: 0.729,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cc",
    x1: 0.864,
    y1: -0.023,
    x2: -0.499,
    y2: -1.789,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dd",
    x1: -0.186,
    y1: 2.701,
    x2: 0.423,
    y2: 1.909,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M195,60H7.5A7.427,7.427,0,0,1,0,52.5V7.5A7.427,7.427,0,0,1,7.5,0H195a7.427,7.427,0,0,1,7.5,7.5v45A7.427,7.427,0,0,1,195,60Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "aaa",
    d: "M195,1.2a6.338,6.338,0,0,1,6.3,6.3v45a6.338,6.338,0,0,1-6.3,6.3H7.5a6.338,6.338,0,0,1-6.3-6.3V7.5A6.338,6.338,0,0,1,7.5,1.2ZM195,0H7.5A7.522,7.522,0,0,0,0,7.5v45A7.427,7.427,0,0,0,7.5,60H195a7.427,7.427,0,0,0,7.5-7.5V7.5A7.522,7.522,0,0,0,195,0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M50.4,11.85a4.086,4.086,0,0,1-1.05,3,4.708,4.708,0,0,1-6.6,0,4.41,4.41,0,0,1-1.35-3.3,4.41,4.41,0,0,1,1.35-3.3,4.41,4.41,0,0,1,3.3-1.35,3.994,3.994,0,0,1,1.8.45A3.266,3.266,0,0,1,49.2,8.4l-.75.75a2.8,2.8,0,0,0-2.4-1.05,2.985,2.985,0,0,0-2.4,1.05A3.09,3.09,0,0,0,42.6,11.7a3.09,3.09,0,0,0,1.05,2.55,3.862,3.862,0,0,0,2.4,1.05,3.29,3.29,0,0,0,2.55-1.05,2.484,2.484,0,0,0,.75-1.8h-3.3v-1.2H50.4ZM57.3,8.1H53.25v2.85H57V12H53.25v2.85H57.3v1.2H52.05v-9H57.3Zm4.95,7.95h-1.2V8.1H58.5V7.05h6.3V8.1H62.25Zm6.9,0v-9h1.2v9Zm6.3,0h-1.2V8.1H71.7V7.05h6.15V8.1H75.3v7.95Zm14.25-1.2a4.708,4.708,0,0,1-6.6,0,4.41,4.41,0,0,1-1.35-3.3,4.41,4.41,0,0,1,1.35-3.3,4.708,4.708,0,0,1,6.6,0,4.41,4.41,0,0,1,1.35,3.3A4.41,4.41,0,0,1,89.7,14.85ZM84,14.1a3.54,3.54,0,0,0,2.4,1.05,2.985,2.985,0,0,0,2.4-1.05,3.619,3.619,0,0,0,1.05-2.55A3.09,3.09,0,0,0,88.8,9a3.54,3.54,0,0,0-2.4-1.05A2.985,2.985,0,0,0,84,9a3.619,3.619,0,0,0-1.05,2.55A3.09,3.09,0,0,0,84,14.1Zm8.7,1.95v-9h1.35L98.4,14.1V7.05h1.2v9H98.4L93.75,8.7v7.35Z",
    transform: "translate(20.7 3.45)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M81.6,24.15a6.311,6.311,0,0,0-6.45,6.45,6.4,6.4,0,0,0,6.45,6.45,6.311,6.311,0,0,0,6.45-6.45A6.223,6.223,0,0,0,81.6,24.15Zm0,10.2a3.723,3.723,0,0,1-3.6-3.9,3.723,3.723,0,0,1,3.6-3.9,3.634,3.634,0,0,1,3.6,3.9A3.723,3.723,0,0,1,81.6,34.35ZM67.65,24.15A6.311,6.311,0,0,0,61.2,30.6a6.4,6.4,0,0,0,6.45,6.45A6.311,6.311,0,0,0,74.1,30.6,6.223,6.223,0,0,0,67.65,24.15Zm0,10.2a3.723,3.723,0,0,1-3.6-3.9,3.723,3.723,0,0,1,3.6-3.9,3.634,3.634,0,0,1,3.6,3.9A3.723,3.723,0,0,1,67.65,34.35ZM51,26.1v2.7h6.45a5.672,5.672,0,0,1-1.5,3.45A6.639,6.639,0,0,1,51,34.2,6.984,6.984,0,0,1,43.95,27,7.076,7.076,0,0,1,51,19.8a7.437,7.437,0,0,1,4.95,1.95L57.9,19.8a9.612,9.612,0,0,0-6.75-2.7A10.119,10.119,0,0,0,41.1,27a10.119,10.119,0,0,0,10.05,9.9,8.632,8.632,0,0,0,6.9-2.85,9.03,9.03,0,0,0,2.4-6.3,5.625,5.625,0,0,0-.15-1.65Zm68.1,2.1a5.828,5.828,0,0,0-5.4-4.05c-3.3,0-6,2.55-6,6.45a6.277,6.277,0,0,0,6.3,6.45,6.153,6.153,0,0,0,5.25-2.85l-2.1-1.5A3.656,3.656,0,0,1,114,34.5a3.254,3.254,0,0,1-3.15-1.95l8.55-3.6Zm-8.7,2.1a3.644,3.644,0,0,1,3.3-3.75,2.653,2.653,0,0,1,2.4,1.35Zm-7.05,6.15h2.85V17.7h-2.85ZM98.85,25.5A4.939,4.939,0,0,0,95.4,24a6.445,6.445,0,0,0-6.15,6.45,6.211,6.211,0,0,0,6.15,6.3,4.307,4.307,0,0,0,3.3-1.5h.15v.9c0,2.4-1.35,3.75-3.45,3.75a3.333,3.333,0,0,1-3.15-2.25l-2.4,1.05a6.188,6.188,0,0,0,5.7,3.75c3.3,0,6-1.95,6-6.6V24.45h-2.7Zm-3.3,8.85a3.723,3.723,0,0,1-3.6-3.9,3.723,3.723,0,0,1,3.6-3.9A3.609,3.609,0,0,1,99,30.45,3.609,3.609,0,0,1,95.55,34.35Zm36.6-16.65H125.4V36.45h2.85V29.4h3.9a5.857,5.857,0,1,0,0-11.7Zm.15,9h-4.05V20.25h4.05a3.3,3.3,0,0,1,3.3,3.15,3.433,3.433,0,0,1-3.3,3.3ZM149.55,24c-2.1,0-4.2.9-4.95,2.85l2.55,1.05a2.65,2.65,0,0,1,2.55-1.35,2.819,2.819,0,0,1,3,2.4v.15a5.95,5.95,0,0,0-2.85-.75c-2.7,0-5.4,1.5-5.4,4.2a4.394,4.394,0,0,0,4.65,4.2,4.221,4.221,0,0,0,3.6-1.8h.15v1.5h2.7v-7.2a5.677,5.677,0,0,0-6-5.25Zm-.3,10.35c-.9,0-2.25-.45-2.25-1.65,0-1.5,1.65-1.95,3-1.95a5.8,5.8,0,0,1,2.55.6A3.493,3.493,0,0,1,149.25,34.35ZM165,24.45l-3.15,8.1h-.15l-3.3-8.1h-3l4.95,11.4-2.85,6.3h2.85L168,24.45Zm-25.2,12h2.85V17.7H139.8Z",
    transform: "translate(20.55 8.55)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M10.6,7.5A2.933,2.933,0,0,0,10,9.6V42.75a2.967,2.967,0,0,0,.75,2.1l.15.15L29.5,26.4v-.3Z",
    transform: "translate(5 3.75)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M29.05,28.55,22.9,22.4v-.45l6.15-6.15.15.15,7.35,4.2c2.1,1.2,2.1,3.15,0,4.35Z",
    transform: "translate(11.45 7.9)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M35.45,26.3,29.15,20,10.4,38.75c.75.75,1.8.75,3.15.15Z",
    transform: "translate(5.2 10)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M35.45,20.114,13.55,7.664c-1.35-.75-2.4-.6-3.15.15l18.75,18.6Z",
    transform: "translate(5.2 3.586)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M35.3,24.1,13.55,36.4a2.453,2.453,0,0,1-3,0l-.15.15.15.15a2.453,2.453,0,0,0,3,0Z",
    transform: "translate(5.2 12.05)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M10.6,38.45a2.933,2.933,0,0,1-.6-2.1v.15a2.967,2.967,0,0,0,.75,2.1v-.15ZM43,21.95l-7.5,4.2.15.15L43,22.1A2.493,2.493,0,0,0,44.5,20C44.5,20.75,43.9,21.35,43,21.95Z",
    transform: "translate(5 10)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M13.75,7.826,43,24.476c.9.6,1.5,1.2,1.5,1.95a2.493,2.493,0,0,0-1.5-2.1L13.75,7.676c-2.1-1.2-3.75-.3-3.75,2.1v.15C10,7.676,11.65,6.626,13.75,7.826Z",
    transform: "translate(5 3.574)"
  })));
};
export default SvgPlaystoreBadge;